import React from 'react';
import { CheckCircle, Mail, Activity } from 'lucide-react';
import { PageType } from '../App';
interface ThankYouPageProps {
  navigate: (page: PageType) => void;
}
export function ThankYouPage({
  navigate
}: ThankYouPageProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-323">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" aria-hidden="true" data-id="element-324">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold-500/5 blur-[120px]" data-id="element-325" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-navy-700/50 blur-[120px]" data-id="element-326" />
      </div>

      <main className="max-w-2xl w-full bg-navy-700/50 border border-gold-500/20 rounded-2xl p-8 md:p-12 text-center shadow-2xl backdrop-blur-sm animate-fadeIn" data-id="element-327">
        <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-8 border border-green-500/30 animate-scaleIn" aria-hidden="true" data-id="element-328">
          <CheckCircle className="w-12 h-12 text-green-400" aria-hidden="true" data-id="element-329" />
        </div>

        <h1 className="text-3xl md:text-5xl font-bold text-gold-500 mb-4 font-serif" data-id="element-330">
          Tu compra está confirmada
        </h1>

        <p className="text-xl text-gray-300 mb-8 font-normal" data-id="element-331">
          Felicitaciones por dar el paso hacia una vida sin depender del dolor.
        </p>

        <section aria-label="Próximos pasos" className="bg-navy-800/80 rounded-xl p-6 mb-8 text-left border border-navy-600" data-id="element-332">
          <h2 className="text-lg font-bold text-white mb-4 flex items-center" data-id="element-333">
            <Mail className="w-5 h-5 mr-2 text-gold-400" aria-hidden="true" data-id="element-334" />
            ¿Qué pasa ahora?
          </h2>
          <ul className="space-y-4 text-gray-300" role="list" data-id="element-335">
            <li className="flex items-start" role="listitem" data-id="element-336">
              <span className="text-gold-500 mr-3 mt-1" aria-hidden="true" data-id="element-337">
                •
              </span>
              <span data-id="element-338">
                En los próximos 5 minutos vas a recibir un correo electrónico
                con el asunto{' '}
                <strong data-id="element-339">&quot;Tu acceso: MÉTODO KINESIO-AHORRO&quot;</strong>.
              </span>
            </li>
            <li className="flex items-start" role="listitem" data-id="element-340">
              <span className="text-gold-500 mr-3 mt-1" aria-hidden="true" data-id="element-341">
                •
              </span>
              <span data-id="element-342">
                Allí encontrarás los enlaces de descarga directa para los 6
                Tomos y los 2 Bonos exclusivos.
              </span>
            </li>
            <li className="flex items-start" role="listitem" data-id="element-343">
              <span className="text-gold-500 mr-3 mt-1" aria-hidden="true" data-id="element-344">
                •
              </span>
              <span data-id="element-345">
                El material está en formato PDF, listo para leer en cualquier
                dispositivo o imprimir.
              </span>
            </li>
          </ul>
        </section>

        <div className="text-gray-400 text-sm mb-8" data-id="element-346">
          <p data-id="element-347">
            ¿No recibiste el correo? Revisá tu carpeta de Spam o Promociones.
          </p>
          <p className="mt-2" data-id="element-348">
            Soporte:{' '}
            <a href="mailto:soporte@fegion.com" className="text-gold-400 underline hover:text-gold-300 transition-colors" data-id="element-349">
              soporte@fegion.com
            </a>
          </p>
        </div>

        <footer className="pt-8 border-t border-navy-600 flex flex-col items-center" data-id="element-350">
          <Activity className="w-8 h-8 text-gold-500/50 mb-4" aria-hidden="true" data-id="element-351" />
          <p className="text-gold-500/70 font-serif italic" data-id="element-352">
            by MÉTODO KINESIO-AHORRO 🇦🇷
          </p>
          <p className="text-xs text-gray-500 mt-2 max-w-xs mx-auto" data-id="element-353">
            Para el argentino adulto que no puede permitirse depender del
            sistema de salud para funcionar cada día.
          </p>
        </footer>
      </main>
    </div>;
}